import React from "react";
//import FlatButton from "material-ui/FlatButton";

import { RefreshButton, Filter, DateInput } from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import DownloadCsvButton from "./DownloadCsvButton";

export const ActivationActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter,
  refresh
}) => (
  <CardActions style={styles.cardActionStyleSmall} className="detail-actions">
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
    <RefreshButton basePath={basePath} refresh={refresh} />
    <DownloadCsvButton basePath={basePath} filterValues={filterValues} />
  </CardActions>
);

export const ActivationFilter = ({ ...props }) => {
  const { filterValues } = props;
  const maxDateTo = new Date();
  // const minDateTo = filterValues.from ? new Date(filterValues.from) : null;
  const maxDateFrom = filterValues.to ? new Date(filterValues.to) : null;
  return (
    <Filter {...props}>
      <DateInput
        source="to"
        label="resources.activation.field.to"
        options={{ maxDate: maxDateTo }}
      />
      <DateInput
        source="from"
        label="resources.activation.field.from"
        options={{ maxDate: maxDateFrom }}
      />
    </Filter>
  );
};



// WEBPACK FOOTER //
// ./src/activations/defaultValues.js